import React from 'react'
import ImageWithBasePath from '../../../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'
import DateComp from '../../../../../core/common/dateComponent/DateComp'
import dayjs from 'dayjs';

const ApptConfirmationLetter = ({ apptConfirmationData }: any) => {

    const formattedTime = dayjs(`1970-01-01T${apptConfirmationData?.result?.aptTime}`).format('h:mm A');


    return (
        <div className='row px-5 mt-3' id='appt-Confirmation'>
            <div className='d-flex gap-2 mb-3'>
                <div>
                    <ImageWithBasePath
                        src="assets/img/logo.svg"
                        className=""
                        alt="Logo"
                        width={120}
                        height={68}
                    />
                </div>
                <div >
                    <p className='mb-0'>
                        <b>
                            CORPORATE OFFICES AND DESIGN CENTER {' '}
                        </b>
                        6825 N. Lincoln Ave., Lincolnwood, IL 60712 <b> BRANCH OFFICE</b> Hinsdale, IL
                    </p>
                    <p>
                        <b>AIROOM INC.</b> - 847.967.ROOM - 847.763.1101 (fax) - <Link to="https:/www.airoom.com" className='text-decoration-underline text-primary'>www.airoom.com</Link>
                    </p>
                </div>
            </div>
            <div className='col-md-12'>
                <h5 className="card-title">{apptConfirmationData?.result?.contactPersons}</h5>
                <p className="card-text mb-0">{apptConfirmationData?.result?.addressLine1}
                </p>
                <p className="card-text">{apptConfirmationData?.result?.cityStateZip}
                </p>

                <p>{apptConfirmationData?.result?.firstNames}</p>

                <p>
                    Thank you for your interest in Airoom Custom Remodeling Specialists. This letter is a confirmation of your appointment: <strong><DateComp formattedDate={apptConfirmationData?.result?.date} />
                        {' '}  at {formattedTime} </strong>
                </p>
                <p>
                    You have taken the first step to improving your lifestyle and home by scheduling a consultation with one of Airoom's Project Development Managers. For this meeting we will need:
                </p>
                <ul className='custom-ul ms-5'>
                    <li>Any existing floor plans or blueprints that you may have</li>
                    <li>Plat of Survey of your home, if available</li>
                    <li>2 to 3 hours of uninterrupted time</li>
                </ul>

                <p>
                    If you have not done so already, you may want to start clipping photos from magazines that illustrate the products and styles you like. They provide us with valuable insights into your personal tastes that we will use during the design development process.
                </p>

                <p>
                    Many of our clients have found it most advantageous to finance their projects through our affiliated mortgage broker, Lamb Financial. As a service to you, we will not only create the best project for your home but the best funding option as well.
                </p>

                <p>
                    Airoom understands that taking on a project like this can be exciting and sometimes a challenging decision to make. You can rest assured that we will do everything we can to help you successfully navigate through this process as we have done for over <strong>10,000 clients</strong>.
                </p>

                <p>
                    To learn more about Airoom and Lamb Financial, please visit our websites at <a href="http://www.airoom.com" target="_blank" className='text-decoration-underline color-red'>www.airoom.com</a> and <a href="http://www.lambmortgage.com" target="_blank" className='text-decoration-underline color-red'>www.lambmortgage.com</a>.
                </p>

                <p>We look forward to helping you fulfill your dreams.</p>

                <p>Sincerely,</p>

                <p>
                    <strong>{apptConfirmationData?.result?.makerName}</strong><br />
                    Executive Vice President
                </p>
            </div>
        </div>
    )
}

export default ApptConfirmationLetter